import type { CurrencyCode } from '@99designs/i18n';
import type { CollaborationMethod } from './ProductGroup';

export type BaseProduct = {
    key: string;
    title: string;
    name: string;
    category: string;
    description: string;
    pricing: { currency: CurrencyCode; amountInCents: number };
};

export interface ContestProduct extends BaseProduct {
    details: Array<string>;
    tier: ContestTier;
}

export enum ContestTier {
    Bronze = 'bronze',
    Silver = 'silver',
    Gold = 'gold',
    Platinum = 'platinum',
}

export interface FixedPriceProjectProduct extends BaseProduct {
    details: Array<FixedPriceProjectProductDetail>;
    additionalDetails: Array<FixedPriceProjectProductAdditionalDetail>;
    disclaimer?: string;
    secondaryCTALink?: string;
    createBriefProductKey?: string;
}

type FixedPriceProjectProductDetail = {
    title: string;
    description: string;
};

export type FixedPriceProjectProductAdditionalDetail = {
    title: string;
    description: string;
    ctaLink: string | null;
};

export interface ProductFeature {
    name: string;
    included: boolean;
    links?: Record<string, string>;
}

export interface ComparativeProduct extends BaseProduct {
    features: ProductFeature[];
    collaborationMethod: CollaborationMethod;
    url?: string;
    tier?: ContestTier;
}
